<script lang="ts">

import { ref, onMounted, onBeforeUnmount } from 'vue';

export default function Breakpoint() {
  const currentBreakpoint = ref('');

  // ブレイクポイントの設定
  const breakpoints = {
    xs: 576,
    sm: 768,
    md: 992,
    lg: 1200,
    xl: 1600
  };

  // ブレイクポイントの幅を取得する関数
  const getWidth = () => {
    return window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
  };

  // 現在のブレイクポイントを取得する関数
  const getCurrent = () => {
    const width = getWidth();
    let current = 'xl'; // デフォルトのブレイクポイント

    for (const bp in breakpoints) {
      if (width < breakpoints[bp]) {
        current = bp;
        break;
      }
    }

    return current;
  };


  // 指定したブレイクポイントより小さいかどうかを判断する関数
  const isBelow = (bp) => {
    const current = getCurrent();
    const currentIdx = Object.keys(breakpoints).indexOf(current);
    const targetIdx = Object.keys(breakpoints).indexOf(bp);

    return currentIdx < targetIdx;
  };

  onMounted(() => {
    currentBreakpoint.value = getCurrent();
    window.addEventListener('resize', handleResize);
  });

  onBeforeUnmount(() => {
    window.removeEventListener('resize', handleResize);
  });

  const handleResize = () => {
    currentBreakpoint.value = getCurrent();
  };

  return {
    isBelow
  };
}
</script>
